import { Icon } from "@iconify/react/dist/iconify.js";

import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import { login } from "../redux/authModalSlice";
import { signinApi } from "../apiHelper/authService";
import { useNavigate } from "react-router-dom";
// import logoImg from "../../src/assets/images/small_svg.svg"
const SignInLayer = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch()
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

const handleChange = (e) => {
  const { name, value } = e.target;
  const updatedValue = name === "email" ? value.toLowerCase() : value;

  setFormData((prev) => ({
    ...prev,
    [name]: updatedValue,
  }));
};

  const handleSignIn = async (e) => {

    e.preventDefault();
    setLoading(true);
    setError("");




    const toastId = toast.loading("Signing your account...");

    try {
      const userData = await signinApi({ email: formData?.email, password: formData?.password });


      dispatch(login(userData));
      toast.success("Log in Successfull", { id: toastId });
      navigate("/")
    } catch (err) {
      console.error("Login Error:", err);


      const errorMessage = err || "Failed to sign up. Please try again.";

      toast.error(errorMessage, { id: toastId });
    } finally {
      setLoading(false);
    }
  }


  return (
    <section className='auth bg-base d-flex flex-wrap'>
      <div className='auth-left d-lg-block d-none'>
        <div className='d-flex align-items-center flex-column h-100 justify-content-center'>
          
          <img src='assets/images/SignIn/banner_image_3.png' alt='' className="h-100 w-100" style={{objectFit:"cover"}} />
        </div>
      </div>
      <div className='auth-right py-32 px-24 d-flex flex-column justify-content-center'>
        <div className='max-w-464-px mx-auto w-100'>
          <div>
            <Link to='/' className='mb-40 max-w-290-px d-flex ' style={{marginLeft:"-20px"}}>
              <img src='assets/images/webLogo/ship_logo.svg' alt='' />
            </Link>
            <h4 className='mb-12'>Sign In to your Account</h4>
            <p className='mb-32 text-secondary-light text-lg'>
              Welcome back! please enter your detail
            </p>
          </div>
          <form onSubmit={handleSignIn}>
            <div className='icon-field mb-16'>
              <span className='icon top-50 translate-middle-y'>
                <Icon icon='mage:email' />
              </span>
              <input
                className='form-control h-56-px bg-neutral-50 radius-12'
                placeholder='Enter Email or Username'
                value={formData?.email}
                onChange={handleChange}
                name="email"
              />
            </div>

            {/* <div className='position-relative mb-20'>
              <div className='icon-field'>
                <span className='icon top-50 translate-middle-y'>
                  <Icon icon='solar:lock-password-outline' />
                </span>
                <input
                  type='password'
                  className='form-control h-56-px bg-neutral-50 radius-12'
                  id='your-password'
                  placeholder='Enter Password'
                  value={formData?.password}
                  onChange={handleChange}
                  name="password"

                />
              </div>
              <span
                className='toggle-password ri-eye-line cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light'
                data-toggle='#your-password'
              />
            </div> */}

            <div className='position-relative mb-20'>
              <div className='icon-field'>
                <span className='icon top-50 translate-middle-y'>
                  <Icon icon='solar:lock-password-outline' />
                </span>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className='form-control h-56-px bg-neutral-50 radius-12'
                  id='your-password'
                  placeholder='Enter Password'
                  value={formData?.password}
                  onChange={handleChange}
                  name="password"
                />
              </div>

              <span
                onClick={() => setShowPassword(prev => !prev)}
                className='toggle-password cursor-pointer position-absolute end-0 top-50 translate-middle-y me-16 text-secondary-light'
              >
                <i className={showPassword ? 'ri-eye-off-line' : 'ri-eye-line'}></i>
              </span>
            </div>


            {/* <div className='d-flex justify-content-between gap-2'>
              <div className='form-check style-check d-flex align-items-center'>
                <input
                  className='form-check-input border border-neutral-300'
                  type='checkbox'
                  id='remember'
                />
                <label className='form-check-label' htmlFor='remember'>
                  Remember me
                </label>
              </div>
            </div> */}

            <button
              type='submit'
              className='btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32'
              disabled={loading}
            >
              {loading ? "Signing In..." : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default SignInLayer;
